var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPAppointmentInStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 3.50004H2.83333V2.33337H12.1667V3.50004ZM8.84167 7.00004C8.375 7.56004 8.08333 8.27171 8.08333 9.04171C8.08333 9.70671 8.33417 10.4184 8.66667 11.0834V11.6667H2.83333V8.16671H2.25V7.00004L2.83333 4.08337H12.1667L12.575 6.12504C12.19 5.93837 11.77 5.83337 11.3267 5.83337L11.21 5.25004H3.79L3.44 7.00004H8.84167ZM7.5 8.16671H4V10.5H7.5V8.16671ZM13.3333 9.04171C13.3333 10.5584 11.2917 12.8334 11.2917 12.8334C11.2917 12.8334 9.25 10.5584 9.25 9.04171C9.25 7.93337 10.1833 7.00004 11.2917 7.00004C12.4 7.00004 13.3333 7.93337 13.3333 9.04171ZM11.9917 9.10004C11.9917 8.75004 11.6417 8.40004 11.2917 8.40004C10.9417 8.40004 10.5917 8.69171 10.5917 9.10004C10.5917 9.45004 10.8833 9.80004 11.2917 9.80004C11.7 9.80004 12.05 9.45004 11.9917 9.10004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPAppointmentInStore);
export default __webpack_public_path__ + "static/media/p_appointment_inStore.96af0caa3feabb91e002ead1a5bfacb4.svg";
export { ForwardRef as ReactComponent };